/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtDiffererDataDto } from '../../models/ot-differer-data-dto';

export interface DiffererOt$Params {
  id_ot: string;
  body: OtDiffererDataDto;
}

export function differerOt(
  http: HttpClient,
  rootUrl: string,
  params: DiffererOt$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, differerOt.PATH, 'patch');
  if (params) {
    rb.path('id_ot', params.id_ot, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    })
  );
}

differerOt.PATH = '/v2/ots/{id_ot}/differer';
